var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CardFaction } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MarketDetailsTab, RoutePath, generateRoutePath } from '../../app/router/config';
import arkhanteBackground from '../../assets/images/backgrounds/background-product-arkhante.png';
import mantrisBackground from '../../assets/images/backgrounds/background-product-mantris.png';
import riftBackground from '../../assets/images/backgrounds/background-product-rift.png';
import buyIcon from '../../assets/images/icons/common/icon-buy-dark.png';
import Details from '../../components/market-details/details';
import FullscreenImage from '../../components/market-details/fullscreen-image';
import Header from '../../components/market-details/header';
import Orders from '../../components/market-details/orders';
import Overview from '../../components/market-details/overview';
import MultiSelectToolbar from '../../components/multi-select-toolbar';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { appEnv } from '../../env';
import { useFilters } from '../../hooks/common/use-filters';
import { useMultipleOrders } from '../../hooks/market/use-multiple-orders';
import { useProduct } from '../../hooks/market/use-product';
import Layout from '../../layout';
import { TokenType } from '../../types/common';
import NotFound from '../error/not-found';
export default function Product() {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var t = useI18n().t;
    var navigate = useNavigate();
    var _f = useParams(), type = _f.type, id = _f.id, tab = _f.tab;
    var selectedWallet = useContext(UserContext).selectedWallet;
    var filters = useFilters({ fromProduct: true });
    var product = useProduct(type, id, filters, tab);
    var _g = useMultipleOrders(product.onSaleOrders || [], function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, product.getOnSaleOrders({ refresh: true })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }), selectedOrderIds = _g.selectedOrderIds, prices = _g.prices, notEnoughCurrency = _g.notEnoughCurrency, selectOrder = _g.selectOrder, shiftSelectOrder = _g.shiftSelectOrder, selectAllOrders = _g.selectAllOrders, unselectedAllOrders = _g.unselectedAllOrders, showBuySingleAssetDialog = _g.showBuySingleAssetDialog, showBuyMultipleAssetsDialog = _g.showBuyMultipleAssetsDialog;
    var _h = useState(false), showFullScreenImage = _h[0], setShowFullScreenImage = _h[1];
    if (!type || !Object.values(TokenType).includes(type) || product.product === null) {
        return _jsx(NotFound, {});
    }
    if (!tab || !Object.values(MarketDetailsTab).includes(tab)) {
        navigate(generateRoutePath(RoutePath.PRODUCT, {
            type: type,
            id: id,
            tab: MarketDetailsTab.OVERVIEW,
        }), { replace: true });
        return _jsx(_Fragment, {});
    }
    if (product.product && product.product.type !== TokenType.CARD && tab === MarketDetailsTab.OVERVIEW) {
        navigate(generateRoutePath(RoutePath.PRODUCT, {
            type: type,
            id: id,
            tab: MarketDetailsTab.ON_SALE,
        }), { replace: true });
        return _jsx(_Fragment, {});
    }
    function getBackground() {
        var _a;
        if (((_a = product.product) === null || _a === void 0 ? void 0 : _a.type) === TokenType.CARD) {
            switch (product.product.data.faction) {
                case CardFaction.ARKHANTE: {
                    return arkhanteBackground;
                }
                case CardFaction.MANTRIS: {
                    return mantrisBackground;
                }
                case CardFaction.RIFT: {
                    return riftBackground;
                }
                default: {
                    return arkhanteBackground;
                }
            }
        }
        return arkhanteBackground;
    }
    var tabs = [
        {
            label: t('market-details.tabs.overview'),
            path: generateRoutePath(RoutePath.PRODUCT, {
                type: type,
                id: id,
                tab: MarketDetailsTab.OVERVIEW,
            }),
            selected: tab === MarketDetailsTab.OVERVIEW,
            undisplayed: ((_a = product.product) === null || _a === void 0 ? void 0 : _a.type) !== TokenType.CARD,
        },
        {
            label: t('market-details.tabs.on-sale'),
            path: generateRoutePath(RoutePath.PRODUCT, {
                type: type,
                id: id,
                tab: MarketDetailsTab.ON_SALE,
            }),
            selected: tab === MarketDetailsTab.ON_SALE,
        },
        {
            label: t('market-details.tabs.details'),
            path: generateRoutePath(RoutePath.PRODUCT, {
                type: type,
                id: id,
                tab: MarketDetailsTab.DETAILS,
            }),
            selected: tab === MarketDetailsTab.DETAILS,
            undisplayed: ((_b = product.product) === null || _b === void 0 ? void 0 : _b.type) !== TokenType.CARD,
        },
        {
            label: t('market-details.tabs.activity'),
            path: generateRoutePath(RoutePath.PRODUCT, {
                type: type,
                id: id,
                tab: MarketDetailsTab.ACTIVITY,
            }),
            selected: tab === MarketDetailsTab.ACTIVITY,
        },
    ];
    var background = getBackground();
    var floorPrice = product.floorPriceOrder
        ? {
            tokenSymbol: product.floorPriceOrder.price.address === appEnv.ctaTokenAddress
                ? CurrencyTokenSymbol.CTA
                : CurrencyTokenSymbol.USDC,
            value: ((_c = product.floorPriceOrder.price.base) === null || _c === void 0 ? void 0 : _c.displayValue) || '',
            usdValue: ((_d = product.floorPriceOrder.price.usd) === null || _d === void 0 ? void 0 : _d.displayValue) || '',
        }
        : undefined;
    return (_jsx(Layout, { background: background, children: _jsx(_Fragment, { children: product.product && (_jsxs(_Fragment, { children: [_jsx(Header, { banner: background, description: product.product.type === TokenType.CARD ? product.product.data.description : undefined, floorPrice: floorPrice, floorPriceOwned: ((_e = product.floorPriceOrder) === null || _e === void 0 ? void 0 : _e.order.user) === (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address), name: product.product.data.name, product: true, showFloorPriceBuyNowDialog: product.showFloorPriceBuyNowDialog, tabs: tabs, tokenType: product.product.type }), tab === MarketDetailsTab.OVERVIEW && (_jsx(Overview, { advancement: product.product.type === TokenType.CARD
                            ? product.product.data.advancement
                            : undefined, floorPrice: floorPrice, ian: product.product.type === TokenType.CARD ? product.product.data.ian : undefined, imageUrl: product.generateCardImage(), metadataItems: product.metadata, onImageClick: function () { return setShowFullScreenImage(true); }, showFloorPriceBuyNowDialog: product.showFloorPriceBuyNowDialog, supply: product.supply, tokenType: product.product.type })), tab === MarketDetailsTab.ON_SALE && (_jsx(Orders, { advancement: product.product.type === TokenType.CARD
                            ? product.product.data.advancement
                            : undefined, availableElements: product.availableElements, buyAction: showBuySingleAssetDialog, filters: filters, imageUrl: product.generateCardImage(true), name: product.product.data.name, orders: product.onSaleOrders, product: true, rarity: product.product.type === TokenType.CARD ? product.product.data.rarity : undefined, selectAllOrders: selectAllOrders, selectOrder: selectOrder, selectedOrderIds: selectedOrderIds, shiftSelectOrder: shiftSelectOrder, tokenType: type })), tab === MarketDetailsTab.DETAILS && (_jsx(Details, { ian: id, imageUrl: product.generateCardImage(), onImageClick: function () { return setShowFullScreenImage(true); }, relatedContent: product.product.type === TokenType.CARD ? product.product.data.relatedContent : undefined, tokenType: product.product.type })), tab === MarketDetailsTab.ACTIVITY && (_jsx(Orders, { activity: true, advancement: product.product.type === TokenType.CARD
                            ? product.product.data.advancement
                            : undefined, availableElements: product.availableElements, buyAction: showBuySingleAssetDialog, filters: filters, imageUrl: product.generateCardImage(true), name: product.product.data.name, orders: product.recentlySoldOrders, product: true, rarity: product.product.type === TokenType.CARD ? product.product.data.rarity : undefined, tokenType: type })), _jsx(FullscreenImage, { background: background, close: function () { return setShowFullScreenImage(false); }, imageUrl: product.generateCardImage(true), visible: showFullScreenImage }), tab === MarketDetailsTab.ON_SALE && (_jsx(MultiSelectToolbar, { actions: [{ action: showBuyMultipleAssetsDialog, text: t('common.buy-now'), icon: buyIcon }], cancel: unselectedAllOrders, fromTable: true, itemsCount: selectedOrderIds.length, notEnoughCurrency: [notEnoughCurrency.cta, notEnoughCurrency.usdc], prices: [prices.cta, prices.usdc] }))] })) }) }));
}
